module.exports = __webpack_public_path__ + "img/xl_logo.515feb49.png";